export default "__VITE_ASSET__2f0d149e__"